const toggleMainMenu = 'toggleMainMenu';
const changedTab = 'changed::tab';
const projectDuplicateSearchTrigger = 'projectDuplicateSearchTrigger';
const editableFieldSaved = 'editableFieldSaved';
const createRoomLayoutChanged = 'createRoomLayoutChanged';
const createRoomUnitsChanged = 'createRoomUnitsChanged';
const checkboxChange = 'input';
const radioSelection = 'select';
const hardwarePackageChanged = 'hardwarePackageChanged';
const selectedFinishChanged = 'selectedFinishChanged';
const selectedPartitionChanged = 'selectedPartitionChanged';
const selectedMaterialChanged = 'selectedMaterialChanged';
const roomEdited = 'roomEdited';
const showDrawingToolbarModal = 'showDrawingToolbarModal';
const showAddressModal = 'showAddressModal';
const showNewQuotesModal = 'showNewQuotesModal';
const showNotesModal = 'showNotesModal';
const showLockerRoomNoteModal = 'showLockerRoomNoteModal';
const showLockerRoomAssistantModal = 'showLockerRoomAssistantModal';
const showSubmittalPackageModal = 'showSubmittalPackageModal';
const roomDesignerModified = 'roomDesignerModified';
const editRoomFinished = 'editRoomFinished';
const enableTooltip = 'bv::enable::tooltip';
const disableTooltip = 'bv::disable::tooltip';
const refresh = 'refresh';
const hoveredAnnotationChanged = 'hoveredAnnotationChanged';
const hoveredLockerStyleChanged = 'hoveredLockerStyleChanged';
const hoveredWallSegmentChanged = 'hoveredWallSegmentChanged';
const hoveredBenchChanged = 'hoveredBenchChanged';
const hoveredBackToBackChanged = 'hoveredBackToBackChanged';
const editedAnnotationChanged = 'editedAnnotationChanged';
const canvasNoteClicked = 'canvasNoteClicked';
const showRoomDesignerModal = 'showRoomDesignerModal';
const focusNewNote = 'focusNewNote';
const notesDetailMounted = 'notesDetailMounted';
const scrollToNote = 'scrollToNote';
const createRoomSelectUnitsNextDisabledChanged = 'createRoomSelectUnitsNextDisabledChanged';
const openProjectPartsModal = 'openProjectpartsModal';
const openAddPartsModal = 'openAddPartsModal';
const openAddElementModal = 'openAddElementModal';
const openResourceCenterModal = 'openResourceCenterModal';
const openLicenseAgreementModal = 'openLicenseAgreementModal';
const openDisableUserModal = 'openDisableUserModal';
const getRoomBom = 'getRoomBom';
const getRoomBomDone = 'getRoomBomDone';
const quoteableOnPrevious = 'quoteable-on-previous';
const updateOrders = 'updateOrders';
const updateOrdersParts = 'updateOrdersParts';
const showRoomPackageModal = 'showRoomPackageModal';
const formatMeasureInput = 'formatMeasureInput';
const toggleOnNoteDuplicationModel = 'toggleOnNoteDuplicationModel';
const forceResetToDefault = 'forceResetToDefault';
const hideContextualMenu = 'hideContextualMenu';
const selectedWashroomAccessoriesTypeChanged = 'selectedWashroomAccessoriesTypeChanged';
const selectedDryerModelChanged = 'selectedDryerModelChanged';
const toggleCardModal = 'toggleCardModal';
const toggleCardPaintModal = 'toggleCardPaintModal';
const toggleDateModal = 'toggleDateModal';
const onDeleteFilter = 'onDeleteFilter';
const updateAffValue = 'updateAffValue';
const showListExportModal = 'showListExportModal';
const exportLeadsList = 'exportLeadsList';
const showOrderStatusModal = 'showOrderStatusModal';
const showLeadsStatusModal = 'showLeadsStatusModal';
const showEmailPackageModal = 'showEmailPackageModal';
const getSubmittalPackage = 'getSubmittalPackage';
const showOrgCompleteContactInfo = 'showOrgCompleteContactInfo';

const Events = {
  toggleMainMenu,
  projectDuplicateSearchTrigger,
  changedTab,
  editableFieldSaved,
  createRoomLayoutChanged,
  createRoomUnitsChanged,
  checkboxChange,
  radioSelection,
  hardwarePackageChanged,
  roomEdited,
  selectedFinishChanged,
  selectedPartitionChanged,
  selectedMaterialChanged,
  selectedDryerModelChanged,
  selectedWashroomAccessoriesTypeChanged,
  showDrawingToolbarModal,
  showAddressModal,
  showNewQuotesModal,
  showNotesModal,
  showLockerRoomNoteModal,
  showLockerRoomAssistantModal,
  showSubmittalPackageModal,
  showRoomPackageModal,
  roomDesignerModified,
  editRoomFinished,
  enableTooltip,
  disableTooltip,
  refresh,
  hoveredAnnotationChanged,
  hoveredLockerStyleChanged,
  hoveredWallSegmentChanged,
  hoveredBenchChanged,
  hoveredBackToBackChanged,
  editedAnnotationChanged,
  canvasNoteClicked,
  showRoomDesignerModal,
  focusNewNote,
  notesDetailMounted,
  scrollToNote,
  getRoomBom,
  getRoomBomDone,
  createRoomSelectUnitsNextDisabledChanged,
  openProjectPartsModal,
  openAddPartsModal,
  openAddElementModal,
  openResourceCenterModal,
  openLicenseAgreementModal,
  openDisableUserModal,
  quoteableOnPrevious,
  updateOrders,
  updateOrdersParts,
  formatMeasureInput,
  toggleOnNoteDuplicationModel,
  forceResetToDefault,
  hideContextualMenu,
  toggleCardModal,
  toggleCardPaintModal,
  toggleDateModal,
  onDeleteFilter,
  updateAffValue,
  showListExportModal,
  exportLeadsList,
  showOrderStatusModal,
  showLeadsStatusModal,
  showEmailPackageModal,
  getSubmittalPackage,
  showOrgCompleteContactInfo,
};

export default Events;
